module.exports = __webpack_public_path__ + "img/view_feedback.3d1bfa73.svg";